import { Box, Stack, Typography } from '@mui/material';

import { ButtonGroup } from '@/components/form/baseInputs/ButtonGroup/ButtonGroup';
import { Checkbox } from '@/components/form/baseInputs/Checkbox/Checkbox';
import { NotificationPreferenceEmailFrequency } from '@/types/schema';

import { NotificationPreferences_NotificationPreferenceFragment } from './graphql/NotificationPreferences.generated';
import { useNotificationPreferenceHandlers } from './hooks/useNotificationPreferenceHandlers';
import {
  COLUMN_WIDTHS,
  EMAIL_FREQUENCY_OPTIONS,
  getNotificationKindLabel,
  REQUIRED_IN_APP_NOTIFICATION_KINDS,
} from './utils';

interface NotificationPreferenceRowProps {
  preference: NotificationPreferences_NotificationPreferenceFragment;
}

export function NotificationPreferenceRow({
  preference,
}: NotificationPreferenceRowProps) {
  const { handleAppEnabledToggle, handleFrequencyChange, saving } =
    useNotificationPreferenceHandlers(preference);
  const isInAppRequired = REQUIRED_IN_APP_NOTIFICATION_KINDS.includes(
    preference.kind
  );

  return (
    <Box sx={{ px: 1, py: 0 }}>
      <Stack
        direction="row"
        gap={2}
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          gap={2}
        >
          <Box sx={{ width: COLUMN_WIDTHS.IN_APP }}>
            <Checkbox
              value={isInAppRequired || preference.appEnabled}
              onChange={handleAppEnabledToggle}
              disabled={saving || isInAppRequired}
            />
          </Box>

          <Box sx={{ width: COLUMN_WIDTHS.EMAIL_FREQUENCY }}>
            <ButtonGroup<NotificationPreferenceEmailFrequency | 'none'>
              hideLabel
              label={`Email frequency for ${getNotificationKindLabel(preference.kind)}`}
              value={
                preference.emailEnabled && preference.emailFrequency
                  ? preference.emailFrequency
                  : 'none'
              }
              onChange={(_event, value) => handleFrequencyChange(value)}
              disabled={saving}
              options={EMAIL_FREQUENCY_OPTIONS}
            />
          </Box>
          <Typography variant="body-s" sx={{ flex: 1, ml: 2 }}>
            {getNotificationKindLabel(preference.kind)}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
